import * as React from "react";
import * as I18n from "../../../utils/translations/I18n";
export var Required = function () {
    return (React.createElement("span", { className: "scl-a-required" },
        React.createElement("sup", { className: "scl-a-required__sup" }, "*"),
        React.createElement("span", { className: "scl-a-required__description" }, I18n.getText("mary.05-atoms.required.text", "Required fields."))));
};
